import { useCallback } from 'react'
import { omit } from '@nwwp/utils'
import { useSegmentAnalytics } from '../components/Provider'

type TrackFlowStepViewedParams = {
  step: string
  type: string
} & Record<string, unknown>

export const useTrackFlowStepViewed = () => {
  const analytics = useSegmentAnalytics()

  return useCallback(
    (params: TrackFlowStepViewedParams) => {
      analytics.track('Flow Step Viewed', {
        ...omit(params, ['step', 'type']),
        step: params.step,
        type: params.type,
      })
    },
    [analytics]
  )
}
